import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/parents/Index.vue'
import Flow from '../views/parents/Flow.vue'
import ScheduleList from '../views/parents/ScheduleList.vue'
import Progress from '../views/parents/Progress.vue'
import ContractList from '../views/parents/ContractList.vue'
import Home from '../views/index/Home.vue'
import About from '../views/index/About.vue'
import Submenu from '../views/flow/Submenu.vue'
import Notice from '../views/flow/Notice.vue'
import FormMakeOut from '../views/flow/FormMakeOut.vue'
import RateOfAdv from '../views/progress/RateOfAdv.vue'
import AuditingWait from '../views/flow/AuditingWait.vue'
import Budget from '../views/flow/Budget.vue'
import Contract from '../views/flow/Contract.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'page',
    redirect: '/index/home',
    meta: {
      title: '营业厅'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      title: '营业厅'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: {
          title: '营业厅'
        }
      },
      {
        path: 'about',
        name: 'about',
        component: About,
        meta: {
          title: '我的'
        }
      }
    ]
  },
  {
    path: '/scheduleList',
    name: 'scheduleList',
    component: ScheduleList,
    meta: {
      title: '进度查询'
    }
  },
  {
    path: '/contractList',
    name: 'contractList',
    component: ContractList,
    meta: {
      title: '我的合同'
    }
  },
  {
    path: '/flow',
    name: 'flow',
    component: Flow,
    children: [
      {
        path: 'submenu',
        name: 'submenu',
        component: Submenu
      },
      {
        path: 'notice',
        name: 'notice',
        component: Notice
      },
      {
        path: 'formMakeOut',
        name: 'formMakeOut',
        component: FormMakeOut,
        meta: {
          title: '填写表单'
        }
      },
      {
        path: 'auditingWait',
        name: 'auditingWait',
        component: AuditingWait,
        meta: {
          title: '业务信息'
        }
      },
      {
        path: 'budget',
        name: 'budget',
        component: Budget,
        meta: {
          title: '工程款缴纳'
        }
      },
      {
        path: 'contract',
        name: 'contract',
        component: Contract,
        meta: {
          title: '电子合同'
        }
      }
    ]
  },
  {
    path: '/progress',
    name: 'progress',
    component: Progress,
    children: [
      {
        path: 'rateOfAdv',
        name: 'rateOfAdv',
        component: RateOfAdv,
        meta: {
          title: '进度'
        }
      },
      {
        path: 'formMakeOut',
        name: 'formMakeOut',
        component: FormMakeOut,
        meta: {
          title: '填写表单'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/index/home',
    meta: {
      title: '营业厅'
    }
  },
  {
    path: 'MP_verify_sDxdAcV1AMD6ZdVu.txt',
    redirect: '/static/MP_verify_sDxdAcV1AMD6ZdVu.txt'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
